module.exports = __webpack_public_path__ + "img/GB-NIR.c39480d5.svg";